export function sentenceCase(input) {
    if (input.length === 0) {
        return input;
    }
    if (input.length === 1) {
        return input[0].toUpperCase();
    }
    return input[0].toUpperCase() + input.substring(1).toLowerCase();
}
//# sourceMappingURL=StringFormatters.js.map